<p-dialog
  header="Export XLS"
  [modal] = "true"
  [(visible)]="showModalExport"
  [style]="{width: '25vw'}">
  <form name="form" [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="form-group">
      <p-checkbox
        formControlName="include_files"
        name="include_files"
        [binary]="true"
        label="Télécharger les fichiers de ressources">
      </p-checkbox>
    </div>
    <br>
    <button type="submit" pButton label="Submit"></button>
    <div class="pt-3" *ngIf="exportChargement">
      <p-progressBar mode="indeterminate" [style]="{ height: '6px' }"></p-progressBar>
    </div>
  </form>
</p-dialog>


<div class="grid">
  <div class="col-12">
    <div class="card">
      <p-table #dt
               [columns]="cols"
               [lazy]="true"
               (onLazyLoad)="loadDatas($event)"
               [value]="ressources"
               dataKey="id"
               [rows]="10"
               [loading]="loading"
               [rowHover]="true"
               styleClass="p-datatable-gridlines"
               [paginator]="true"
               [totalRecords]="totalRecords"
               [rowsPerPageOptions]="[10, 20, 50, 100,250,500,1000,2000]"
               [globalFilterFields]="['CodeProjet']"
               responsiveLayout="scroll">
        <ng-template pTemplate="caption">
          <div class="flex justify-content-right flex-column sm:flex-row">
            <button pButton
                    label="Clear"
                    class="p-button-outlined mb-2 mr-2"
                    icon="pi pi-filter-slash"
                    (click)="clear(dt)"></button>
            <button type="button"
                    pButton
                    pRipple
                    icon="pi pi-file"
                    (click)="exportCsv()"
                    class="mr-2"
                    pTooltip="CSV"
                    [disabled]="!this.idsToExport.length"
                    [style]="{'background-color': !this.idsToExport.length ? 'grey' : ''}"
                    tooltipPosition="bottom"></button>
            <button type="button"
                    pButton
                    pRipple
                    icon="pi pi-file-excel"
                    (click)="showModalExport = true"
                    class="p-button-success mr-2"
                    pTooltip="XLS"
                    tooltipPosition="bottom"
                    [disabled]="!this.idsToExport.length"
                    [style]="{'background-color': !this.idsToExport.length ? 'grey' : ''}"
            ></button>
            <!--<button type="button"
                    pButton
                    pRipple
                    icon="pi pi-file-excel"
                    (click)="exportExcelBackend()"
                    class="p-button-success mr-2"
                    [disabled]="!this.idsToExport.length"
                    [style]="{'background-color': !this.idsToExport.length ? 'grey' : ''}"
                    pTooltip="XLS BACKEND"
                    tooltipPosition="bottom"></button>
                       <button type="button"-->
            <!--                    pButton-->
            <!--                    pRipple-->
            <!--                    icon="pi pi-filter"-->
            <!--                    (click)="dt.exportCSV({ selectionOnly: true })"-->
            <!--                    class="p-button-info ml-auto"-->
            <!--                    pTooltip="Selection Only"-->
            <!--                    tooltipPosition="bottom"></button>-->

          </div>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th>
              Selection export
            </th>
            <th>
              <div class="flex justify-content-between align-items-center">
                EAN
              </div>
            </th>

            <th>
              <div class="flex justify-content-between align-items-center">
                Code article
              </div>
            </th>

            <th>
              <div class="flex justify-content-between align-items-center">
                Statut
              </div>
            </th>

            <th>
              <div class="flex justify-content-between align-items-center">
                Collection
              </div>
            </th>

            <th>
              <div class="flex justify-content-between align-items-center">
                Matière(s)
              </div>
            </th>

            <th>
              <div class="flex justify-content-between align-items-center">
                Classe(s)
              </div>
            </th>

            <th>
              <div class="flex justify-content-between align-items-center">
                Date de mise en vente ouvrage
              </div>
            </th>

            <th>
              <div class="flex justify-content-between align-items-center">
                Code projet
              </div>
            </th>

            <th>
              <div class="flex justify-content-between align-items-center">
                Titre de la ressource
              </div>
            </th>

            <th>
              <div class="flex justify-content-between align-items-center">
                Catégorie
              </div>
            </th>

            <th>
              <div class="flex justify-content-between align-items-center">
                Type
              </div>
            </th>

            <th>
              <div class="flex justify-content-between align-items-center">
                Nom de fichier
              </div>
            </th>

            <th>
              <div class="flex justify-content-between align-items-center">
                Complétion média
              </div>
            </th>

            <th>
              <div class="flex justify-content-between align-items-center">
                Chapitre
              </div>
            </th>

            <th>
              <div class="flex justify-content-between align-items-center">
                Page
              </div>
            </th>

            <th>
              <div class="flex justify-content-between align-items-center">
                Destination(s)
              </div>
            </th>

            <th>
              <div class="flex justify-content-between align-items-center">
                Cible (T/P)
              </div>
            </th>

            <th>
              <div class="flex justify-content-between align-items-center">
                Afficher la ressource
              </div>
            </th>

            <th>
              <div class="flex justify-content-between align-items-center">
                Télécharger la ressource
              </div>
            </th>

            <th>
              <div class="flex justify-content-between align-items-center">
                Accès au projet
              </div>
            </th>

          </tr>
          <tr>
            <th>
              <input type="checkbox"
                     name="exportCheckBox"
                     (click)="addIdsForExport($event,'all')">
            </th>
            <th>
              <div class="flex justify-content-between align-items-center">
                <p-columnFilter type="text"
                                field="ouvrage.BaseArticle.EAN"
                                matchMode="contains"
                                [showMenu]="false"></p-columnFilter>
              </div>
            </th>

            <th>
              <div class="flex justify-content-between align-items-center">
                <p-columnFilter type="text"
                                field="ouvrage.BaseArticle.CodeArticle"
                                matchMode="contains"
                                [showMenu]="false"></p-columnFilter>
              </div>
            </th>

            <th>
              <div class="flex justify-content-between align-items-center" *ngIf="classDefBaseArticle">
                <p-columnFilter field="ouvrage.BaseArticle.StatutArticle"
                                matchMode="equals"
                                [showMenu]="false">
                  <ng-template pTemplate="filter"
                               let-value
                               let-filter="filterCallback">
                    <p-multiSelect [ngModel]="value"
                                optionLabel="key"
                                optionValue="value"
                                placeholder="Tous"
                                appendTo="body"
                                [options]="classDefBaseArticle.fdef['StatutArticle'].options"
                                (onChange)="filter($event.value)"
                                [style]="{'min-width': '12rem'}">
                      <ng-template let-option
                                   pTemplate="item">
                        <span [class]="'customer-badge status-' + option.value">{{option.key}}</span>
                      </ng-template>
                    </p-multiSelect>
                  </ng-template>
                </p-columnFilter>
              </div>
            </th>

            <th>
              <div class="flex justify-content-between align-items-center">
                <p-columnFilter type="text"
                                field="ouvrage.BaseArticle.NomCollection"
                                matchMode="contains"
                                [showMenu]="false"></p-columnFilter>
              </div>
            </th>

            <th>
              <div class="flex justify-content-between align-items-center" *ngIf="classDefBaseArticle">
                <p-columnFilter field="ouvrage.BaseArticle.Matieres"
                                matchMode="contains"
                                [showMenu]="false">
                  <ng-template pTemplate="filter"
                               let-value
                               let-filter="filterCallback">
                    <p-multiSelect [ngModel]="value"
                                optionLabel="key"
                                optionValue="value"
                                placeholder="Tous"
                                appendTo="body"
                                [options]="classDefBaseArticle.fdef['Matieres'].options"
                                (onChange)="filter($event.value)"
                                [style]="{'min-width': '12rem'}">
                      <ng-template let-option
                                   pTemplate="item">
                        <span [class]="'customer-badge status-' + option.value">{{option.key}}</span>
                      </ng-template>
                    </p-multiSelect>
                  </ng-template>
                </p-columnFilter>
              </div>
            </th>

            <th>
              <div class="flex justify-content-between align-items-center" *ngIf="classDefBaseArticle">
                <p-columnFilter field="ouvrage.BaseArticle.Classe"
                                matchMode="contains"
                                [showMenu]="false">
                  <ng-template pTemplate="filter"
                               let-value
                               let-filter="filterCallback">
                    <p-multiSelect [ngModel]="value"
                                optionLabel="key"
                                optionValue="value"
                                placeholder="Tous"
                                appendTo="body"
                                [options]="classDefBaseArticle.fdef['Classe'].options"
                                (onChange)="filter($event.value)"
                                [style]="{'min-width': '12rem'}">
                      <ng-template let-option
                                   pTemplate="item">
                        <span [class]="'customer-badge status-' + option.value">{{option.key}}</span>
                      </ng-template>
                    </p-multiSelect>
                  </ng-template>
                </p-columnFilter>
              </div>
            </th>

            <th>
              <div class="flex justify-content-between align-items-center">
                <p-columnFilter type="text"
                                field="ouvrage.CodeProjet"
                                matchMode="contains"
                                [showMenu]="false"></p-columnFilter>
              </div>
            </th>

            <th>
              <div class="flex justify-content-between align-items-center">
                <p-columnFilter type="date"
                                field="ouvrage.BaseArticle.DateParution"
                                matchMode="equals"
                                [showMenu]="false"></p-columnFilter>
              </div>
            </th>

            <th>
              <div class="flex justify-content-between align-items-center">
                <p-columnFilter type="text"
                                field="titreEditeur"
                                matchMode="contains"
                                [showMenu]="false"></p-columnFilter>
              </div>
            </th>

            <th>
              <div class="flex justify-content-between align-items-center" *ngIf="classDef">
                <p-columnFilter field="categorie"
                                matchMode="contains"
                                [showMenu]="false">
                  <ng-template pTemplate="filter"
                               let-value
                               let-filter="filterCallback">
                    <p-multiSelect [ngModel]="value"
                                optionLabel="key"
                                optionValue="value"
                                placeholder="Tous"
                                appendTo="body"
                                [options]="classDef.fdef['categorie'].options"
                                (onChange)="filter($event.value)"
                                [style]="{'min-width': '12rem'}">
                      <ng-template let-option
                                   pTemplate="item">
                        <span [class]="'customer-badge status-' + option.value">{{option.key}}</span>
                      </ng-template>
                    </p-multiSelect>
                  </ng-template>
                </p-columnFilter>
              </div>
            </th>

            <th>
              <div class="flex justify-content-between align-items-center">
                <p-columnFilter field="format.id"
                                matchMode="contains"
                                [showMenu]="false">
                  <ng-template pTemplate="filter"
                               let-value
                               let-filter="filterCallback">
                    <p-multiSelect [ngModel]="value"
                                optionLabel="key"
                                optionValue="value"
                                placeholder="Tous"
                                appendTo="body"
                                [options]="formats"
                                (onChange)="filter($event.value)"
                                [style]="{'min-width': '12rem'}">
                      <ng-template let-option
                                   pTemplate="item">
                        <span>{{option.key}}</span>
                      </ng-template>
                    </p-multiSelect>
                  </ng-template>
                </p-columnFilter>
              </div>
            </th>

            <th>
              <div class="flex justify-content-between align-items-center">
                <p-columnFilter type="text"
                                field="filename"
                                matchMode="contains"
                                [showMenu]="false"></p-columnFilter>
              </div>
            </th>

            <th></th>

            <th>
              <div class="flex justify-content-between align-items-center">
                <p-columnFilter type="text"
                                field="structure"
                                matchMode="contains"
                                [showMenu]="false"></p-columnFilter>
              </div>
            </th>

            <th>
              <div class="flex justify-content-between align-items-center">
                <p-columnFilter type="text"
                                field="pageAtterrissage.idPage"
                                matchMode="contains"
                                [showMenu]="false"></p-columnFilter>
              </div>
            </th>

            <th></th>

            <th>
              <div class="flex justify-content-between align-items-center" *ngIf="classDef">
                <p-columnFilter field="cible"
                                matchMode="contains"
                                [showMenu]="false">
                  <ng-template pTemplate="filter"
                               let-value
                               let-filter="filterCallback">
                    <p-multiSelect [ngModel]="value"
                                optionLabel="key"
                                optionValue="value"
                                placeholder="Tous"
                                appendTo="body"
                                [options]="classDef.fdef['cible'].options"
                                (onChange)="filter($event.value)"
                                [style]="{'min-width': '12rem'}">
                      <ng-template let-option
                                   pTemplate="item">
                        <span [class]="'customer-badge status-' + option.value">{{option.key}}</span>
                      </ng-template>
                    </p-multiSelect>
                  </ng-template>
                </p-columnFilter>
              </div>
            </th>

            <th></th>
            <th></th>
            <th></th>

          </tr>
        </ng-template>
        <ng-template pTemplate="body"
                     let-ressource>
          <tr>
            <td>
              <input type="checkbox"
                     name="exportCheckBox"
                     (click)="addIdsForExport($event,ressource.id)"
                     #exportCheckBox>
            </td>
            <td style="min-width: 12rem;">
              {{ressource.ouvrage.BaseArticle.EAN}}
            </td>
            <td style="min-width: 12rem;">
              {{ressource.ouvrage.BaseArticle.CodeArticle}}
            </td>
            <td style="min-width: 12rem;" *ngIf="classDefBaseArticle">
              {{classDefBaseArticle.fdef['StatutArticle'].optionsLabel[[ressource.ouvrage.BaseArticle.StatutArticle]]}}
            </td>
            <td style="min-width: 12rem;">
              {{ressource.ouvrage.BaseArticle.NomCollection}}
            </td>

            <td style="min-width: 12rem;">
              {{getLabelValues(ressource.ouvrage.BaseArticle.Matieres, 'Matieres')}}
            </td>

            <td style="min-width: 12rem;">
              {{getLabelValues(ressource.ouvrage.BaseArticle.Classe, 'Classe')}}
            </td>
            <td style="min-width: 12rem;">
              {{ressource.ouvrage.BaseArticle.DateParution | date:'d-LL-Y'}}
            </td>
            <td style="min-width: 12rem;">
              {{ressource.ouvrage.CodeProjet}}
            </td>

            <td style="min-width: 12rem;"
                [innerHTML]="ressource.titreEditeur">
            </td>

            <td style="min-width: 12rem;" *ngIf="classDef">
              {{classDef.fdef['categorie'].optionsLabel[[ressource.categorie]]}}
            </td>

            <td style="min-width: 12rem;">
              {{ressource.format !== null ? ressource.format.nom : ''}}
            </td>

            <td style="min-width: 12rem;">
              {{ressource.filename}}
            </td>

            <td style="min-width: 12rem;">
              <div role="progressbar"
                   aria-valuemin="0"
                   aria-valuemax="100"
                   class="p-progressbar p-component p-progressbar-determinate">
                <div
                  class="p-progressbar-value p-progressbar-value-animate ng-star-inserted"
                  style="display: flex; width: {{getCompletionMedia(ressource)}}%;">
                  <div
                    class="p-progressbar-label ng-star-inserted"
                    style="display:flex;">{{getCompletionMedia(ressource)}}%
                  </div>
                </div>
              </div>
            </td>

            <td style="min-width: 12rem;">
              {{ressource.structure}}
            </td>

            <td style="min-width: 12rem;">
              <span *ngFor="let page of ressource.pageAtterrissage; let last = last">
                {{page.idPage}}<ng-container *ngIf="page.numeroFolio"> (folio {{page.numeroFolio}})</ng-container>{{last ? '' : ', '}}
              </span>
            </td>

            <td style="min-width: 12rem;">
              {{ getDestination(ressource)}}
            </td>

            <td style="min-width: 12rem;" *ngIf="classDef">
              {{classDef.fdef['cible'].optionsLabel[[ressource.cible]]}}
            </td>

            <td>
              <a *ngIf="ressource.miniliens.length > 0"
                 href="{{ressource.miniliens[0]['url_longue']}}"
                 target="_blank"
                 class="pi pi-link"></a>
            </td>

            <td style="min-width: 12rem;">
              <p-button *ngIf="ressource.format !== 'url'"
                        icon="pi pi-download"
                        class="mr-2 mb-2"
                        (click)="downloadFile(ressource.id)"></p-button>
              <a *ngIf="ressource.format === 'url'"
                 href="{{ ressource.url}}">Regarder la vidéo</a>
            </td>

            <td style="min-width: 12rem;" class="text-center">
              <a *ngIf="getOuvrageLink(ressource) as ouvrageLink"
                 pButton
                 pRipple
                 [routerLink]="ouvrageLink"
                 label="Accès au projet"
                 class="mr-2 mb-2"></a>
            </td>

          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="7">No customers found.</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="loadingbody">
          <tr>
            <td colspan="7">Loading customers data. Please wait.</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
